module.exports = require("swagger-client");


//////////////////
// WEBPACK FOOTER
// external "swagger-client"
// module id = 239
// module chunks = 0